import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { FEATURE_FLAGS } from 'utils/constants';
import { useFeatureFlagContext } from 'v2/context/featureFlagContext';
import { GenericObject, User } from 'v2/models';
import BuyerFileLibrary from './BuyerFileLibrary/BuyerFileLibrary';
import ProviderFileLibrary from './ProviderFileLibrary/ProviderFileLibrary';

interface StateProps {
  user: User;
}

const FileLibrary = ({ user }: StateProps) => {
  const { flags } = useFeatureFlagContext();

  const redirectToHome = () => {
    return <Redirect to="/" />;
  };

  if (user.organization) {
    return flags[FEATURE_FLAGS.DATA_BUYER_FILE_LIBRARY] ? (
      <BuyerFileLibrary />
    ) : (
      redirectToHome()
    );
  }

  return flags[FEATURE_FLAGS.DATA_FILE] ? (
    <ProviderFileLibrary />
  ) : (
    redirectToHome()
  );
};

const mapStateToProps = (state: GenericObject) => {
  return {
    user: state.user.user,
  };
};

export default connect<StateProps>(mapStateToProps)(FileLibrary);
